import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateTiktokIntegrationMutation = createMutationHook(
  ShopRendererApiClient.updateTiktokIntegration,
  {
    mutationKey: ['updateTiktokIntegration'],
  },
)
